<template>
	<div class="w-full">
		<div class="mb-3">
			<span class="mb-0 font-medium text-gray-650">Price</span>
		</div>

		<div v-if="isDirty" class="m-0 space-y-3 p-0">
			<FilterSelectbox
				v-model="priceFrom"
				mode="single"
				:options="priceFromOptions"
				value-prop="value"
				label="label"
				placeholder="From"
				:searchable="true"
				:groups="false"
				:close-on-select="true"
				:hide-selected="false"
				:show-apply-and-clear="false"
				:can-clear="false"
				:can-deselect="false"
				@change="onChange($event, 'priceFrom')"
			/>

			<FilterSelectbox
				v-model="priceTo"
				mode="single"
				:options="priceToOptions"
				value-prop="value"
				label="label"
				placeholder="To"
				:searchable="true"
				:groups="false"
				:close-on-select="true"
				:hide-selected="false"
				:show-apply-and-clear="false"
				:can-clear="false"
				:can-deselect="false"
				@change="onChange($event, 'priceTo')"
			/>
		</div>

		<div v-if="showContentLoader" class="flex flex-col gap-2">
			<!-- <ContentLoader viewBox="0 0 250 80">
				<rect x="0" y="0" rx="3" ry="3" width="100%" height="35" />
				<rect x="0" y="45" rx="3" ry="3" width="100%" height="35" />
			</ContentLoader> -->
			<ContentLoader width="w-full" height="h-[50px]" />
			<ContentLoader width="w-full" height="h-[50px]" />
		</div>
	</div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import FilterSelectbox from '@/components/selectboxes/FilterSelectbox.vue'
import { useProductCatalog } from '@/stores/product-catalog'
import ContentLoader from '@/components/ContentLoader.vue'

const productCatalog = useProductCatalog()

const priceFrom = ref(
	productCatalog.filters.priceFrom ? productCatalog.filters.priceFrom : 'all'
)
const priceTo = ref(
	productCatalog.filters.priceTo ? productCatalog.filters.priceTo : 'all'
)

const priceFromOptionsOriginal = computed(() => productCatalog.facets.priceFrom)

const priceToOptionsOriginal = computed(() => productCatalog.facets.priceTo)

const priceFromOptions = computed(() => {
	const options = []
	priceFromOptionsOriginal.value.forEach((option) => {
		if (
			priceTo.value &&
			option.value !== 'all' &&
			parseInt(option.value, 10) >= parseInt(priceTo.value, 10)
		) {
			return
		}

		options.push(option)
	})

	return options
})

const priceToOptions = computed(() => {
	const options = []
	priceToOptionsOriginal.value.forEach((option) => {
		if (
			priceFrom.value &&
			option.value !== 'all' &&
			parseInt(option.value, 10) <= parseInt(priceFrom.value, 10)
		) {
			return
		}

		options.push(option)
	})

	return options
})

const isDirty = computed(() => productCatalog.isDirty)

const showContentLoader = computed(() => !isDirty.value)

watch(
	() => productCatalog.filters.priceFrom,
	(newValue) => {
		priceFrom.value =
			newValue === null || newValue === '' ? 'all' : newValue
	}
)

watch(
	() => productCatalog.filters.priceTo,
	(newValue) => {
		priceTo.value = newValue === null || newValue === '' ? 'all' : newValue
	}
)

const onChange = (filterValue, filterKey) => {
	const updateFilterValue = filterValue === 'all' ? null : filterValue

	productCatalog.updateFilter({
		filterKey,
		filterValue: updateFilterValue,
	})
}
</script>
